<template>
  <form class="form needs-validation" novalidate="novalidate">
    <slot
      v-if="$slots.formView"
      name="formView"
      :ajaxTargetLoad="ajaxTargetLoad"
      :ajaxTargetTrig="ajaxTargetTrig"
      :resetInputs="resetInputs"
      :toggle="toggle"
      :draft="draft"
      :filter="filter"
    ></slot>
    <div class="grid" v-else>
      <div :class="'row w-100 ' + (justifyRowEnd ? 'justify-content-end' : '')">
        <template v-for="model in formModels" :key="model?.vars?.id">
          <div v-if="model.vars.line_break" class="col-12"></div>
          <div
            v-if="(!model.vars.attr || !model.vars.attr['data-form-sticky']) && !model.vars.hide"
            :class="
              'form-group ' +
              (model.vars.row_attr && model.vars.row_attr.class ? ' ' + model.vars.row_attr.class : '') +
              (model.vars.toggle_class ? ' d-none ' + model.vars.toggle_class.replaceAll('\\', '') : '')
            "
          >
            <ModelComponent
              :disableFocusAnimation="disableFocusAnimation"
              :isFiltered="isFiltered"
              :model="model"
              @ajaxTargetLoad="ajaxTargetLoad"
              @ajaxTargetTrig="ajaxTargetTrig"
              @update="update"
              @toggle="toggle"
              @input="input"
              @uploading="uploading"
              @uploaded="uploaded"
              @dateChanged="dateChanged"
              @resetInputs="resetInputs"
              @sortCollection="sortCollection"
              @resetFilter="resetFilter"
              @filter="filter"
              @draft="draft"
              @selected="selected"
              @addEditAction="addEditAction"
              @toggleTab="toggleTab"
              @selectTypeAction="selectTypeAction"
              @buttonAction="buttonAction"
              @fetchConditionalChildren="fetchConditionalChildren"
            />
            <ModelChildrenComponent
              v-if="model?.vars?.attr['hasChildren'] && Object.keys(model?.children).length"
              :model="model"
              :disableFocusAnimation="disableFocusAnimation"
              :isFiltered="isFiltered"
              @ajaxTargetLoad="ajaxTargetLoad"
              @ajaxTargetTrig="ajaxTargetTrig"
              @update="update"
              @toggle="toggle"
              @input="input"
              @uploading="uploading"
              @uploaded="uploaded"
              @dateChanged="dateChanged"
              @resetInputs="resetInputs"
              @sortCollection="sortCollection"
              @resetFilter="resetFilter"
              @filter="filter"
              @draft="draft"
              @selected="selected"
              @addEditAction="addEditAction"
              @toggleTab="toggleTab"
              @selectTypeAction="selectTypeAction"
              @buttonAction="buttonAction"
              @fetchConditionalChildren="fetchConditionalChildren"
            />
          </div>
        </template>
      </div>
      <div v-if="stickyFields.length" class="stickyForm">
        <div class="stickyForm__content">
          <template v-for="model in stickyFields" :key="model.vars.id">
            <div
              v-if="model.vars.attr && model.vars.attr['data-form-sticky']"
              :class="
                'form-group ' +
                (model.vars.row_attr && model.vars.row_attr.class ? ' ' + model.vars.row_attr.class : '') +
                (model.vars.toggle_class ? ' d-none ' + model.vars.toggle_class.replaceAll('\\', '') : '')
              "
            >
              <ModelComponent
                :disableFocusAnimation="disableFocusAnimation"
                :isFiltered="isFiltered"
                :model="model"
                @ajaxTargetLoad="ajaxTargetLoad"
                @ajaxTargetTrig="ajaxTargetTrig"
                @update="update"
                @toggle="toggle"
                @uploading="uploading"
                @uploaded="uploaded"
                @resetFilter="resetFilter"
                @filter="filter"
                @selected="selected"
                @addEditAction="addEditAction"
                @toggleTab="toggleTab"
                @buttonAction="buttonAction"
                @selectTypeAction="selectTypeAction"
                @fetchConditionalChildren="fetchConditionalChildren"
              />
            </div>
          </template>
        </div>
      </div>
    </div>
    <SubmitTypeComponent
      v-if="(!submitModel || (submitModel && submitModel.vars.display)) && !hideSubmit"
      :defaultColors="defaultColors"
      :model="submitModel"
      :standAlone="standAlone"
      :submitText="submitText"
      :disabledSubmit="disabledSubmit"
      :loading="fileUploading"
      :hideCancel="hideCancel"
      :disabledSumit="disabledSumit"
      @cancelForm="cancel()"
      @submitForm="submit()"
    />
  </form>
</template>
<script>
import SubmitTypeComponent from "@/components/form/SubmitTypeComponent.vue";
import { formValidator } from "@/services/form/form-validator";
import ModelComponent from "@/components/form/ModelComponent.vue";
import { formManager } from "@/services/form/form-manager";
import { mapActions } from "pinia";
import { useFormStore } from "@/store/form/form";
import ModelChildrenComponent from "@/components/form/list/ModelChildrenComponent.vue";

export default {
  name: "FormComponent",
  components: {
    ModelChildrenComponent,
    ModelComponent,
    SubmitTypeComponent,
  },
  data() {
    return {
      errors: [],
      formModels: this.models,
      submitModel: null,
      stickyFields: [],
      fileUploading: false,
      labelChoices: {
        vars: {
          block_prefixes: ["", "choice"],
          label: false,
          expanded: false,
          multiple: true,
          name: "labelChoices",
          value: "",
          required: true,
          id: "labelChoices",
          choices: this.labelChoices,
        },
      },
    };
  },
  emits: [
    "update",
    "uploaded",
    "uploading",
    "formSubmit",
    "formCancel",
    "toggle",
    "draft",
    "sortCollection",
    "filter",
    "resetFilter",
    "selected",
    "addEditAction",
    "input",
    "toggleTab",
    "selectTypeAction",
    "buttonAction",
    "checkChildrenToReset",
    "fetchConditionalChildren",
  ],
  props: {
    models: {
      type: [Array, Object],
      required: true,
    },
    disableFocusAnimation: {
      type: Boolean,
      required: false,
      default: false,
    },
    defaultColors: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideSubmit: {
      type: Boolean,
      required: false,
      default: false,
    },
    keepHideValue: {
      type: Boolean,
      required: false,
      default: false,
    },
    standAlone: {
      type: Boolean,
      required: false,
      default: false,
    },
    hideCancel: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: null,
    },
    submitText: {
      type: String,
      required: false,
      default: null,
    },
    disabledSubmit: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFiltered: {
      type: Boolean,
      required: false,
      default: false,
    },
    justifyRowEnd: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  updated() {
    this.retrieveSubmitModel();
  },
  created() {
    this.retrieveSubmitModel();
  },
  mounted() {
    this.isStickyBlock();
    Object.values(this.models).forEach(
      function (model) {
        if (model.children && model.children.length) {
          model.children.forEach((child) => {
            Object.values(child.children).forEach((value) => {
              this.checkToggleTarget(value);
            });
          });
        }
        this.checkToggleTarget(model);
        this.dateChanged(model);
      }.bind(this),
    );
  },
  unmounted() {
    this.resetParentAjaxParamsCorrespondingTable();
  },
  methods: {
    submit() {
      if (this.type === "trainingCourse_duplication") {
        const result = {
          ...this.formModels.referenceColumn.children,
          ...this.formModels.destinationColumn.children,
        };
        this.errors = formValidator.validForm(result);
        if (!this.errors.length && !this.fileUploading) {
          this.$emit("formSubmit", result);
        }
      } else {
        this.errors = formValidator.validForm(this.formModels);
        if (!this.errors.length && !this.fileUploading) {
          this.$emit("formSubmit", this.formModels);
        }
      }
    },
    cancel() {
      this.$emit("formCancel");
    },
    retrieveSubmitModel() {
      let response = null;
      Object.values(this.models).forEach(function (model) {
        if (formManager.isSubmitType(model)) {
          response = model;
        }
      });
      this.submitModel = response;
    },
    update(payload) {
      this.resetChildrenValue(payload.model);

      this.$emit("update");
    },
    draft(value) {
      this.$emit("draft", value);
    },
    selected(value) {
      this.$emit("selected", value);
    },
    addEditAction(value) {
      this.$emit("addEditAction", value);
    },
    input(value) {
      this.$emit("input", value);
    },
    toggle(model) {
      this.$emit("toggle", model);
      this.checkToggleTarget(model);
    },

    uploading() {
      this.$emit("uploading");
      this.fileUploading = true;
    },

    uploaded(data) {
      this.fileUploading = false;
      this.$emit("uploaded", data);
    },

    dateChanged(model) {
      if (formManager.isDateType(model)) {
        Object.values(this.models).forEach((item) => {
          if (item.children) {
            if (!Object.keys(item.children).length || formManager.isDateType(item)) {
              if (
                item.vars.attr &&
                (item.vars.attr["data-day-ref"] ||
                  item.vars.attr["data-hour-ref"] ||
                  item.vars.attr["data-datehour-ref"])
              ) {
                this.addDateRules(item, model);
              }
            } else {
              Object.values(item.children).forEach((child) => {
                if (
                  child.vars.attr &&
                  (child.vars.attr["data-day-ref"] ||
                    child.vars.attr["data-hour-ref"] ||
                    item.vars.attr["data-datehour-ref"])
                ) {
                  this.addDateRules(child, model);
                }
              });
            }
          }
        });
      }
    },

    addDateRules(model, ref) {
      let minTime = null;
      if (ref.vars.value) {
        if (model.vars.attr["data-day-ref"] === ref.vars.name) {
          minTime = ref.vars.value.split(" ")[0];
        } else if (model.vars.attr["data-hour-ref"] === ref.vars.name) {
          if (formManager.isTimeType(ref)) {
            minTime = ref.vars.value;
          } else {
            minTime = ref.vars.value.split(" ")[1].slice(0, -3);
          }
        } else if (model.vars.attr["data-datehour-ref"] === ref.vars.name) {
          minTime = ref.vars.value;
        }

        if (minTime) {
          model.vars.attr["data-min-date"] = minTime;
          if (minTime > model.vars.value) {
            model.vars.value = minTime;
          }
        }
      }
    },

    checkToggleTarget(model) {
      formManager.checkToggleTarget(this.models, model, this.keepHideValue);
    },

    ajaxTargetLoad(payload) {
      if (this.type === "trainingCourse_duplication") {
        if (this.models.referenceColumn.children[payload.target]) {
          this.formModels.referenceColumn.children[payload.target].vars.choices = payload.choices;
          this.formModels.referenceColumn.children[payload.target].vars.value = Object.values(payload.choices).find(
            (choice) => choice.value.toString() === this.formModels.referenceColumn.children[payload.target].vars.value,
          );
        }
      } else {
        if (this.models[payload.target]) {
          this.formModels[payload.target].vars.choices = payload.choices;
          if (
            Object.values(payload.choices).find(
              (choice) => choice.value.toString() === this.formModels[payload.target].vars.value,
            )
          ) {
            this.formModels[payload.target].vars.value = Object.values(payload.choices).find(
              (choice) => choice.value.toString() === this.formModels[payload.target].vars.value,
            );
          }
        } else if (
          payload.parent &&
          this.formModels[payload.parent] &&
          this.formModels[payload.parent].vars.block_prefixes.includes("collection")
        ) {
          this.formModels[payload.parent].children[payload.index].children[payload.target].vars.choices =
            payload.choices;
          this.formModels[payload.parent].children[payload.index].children[payload.target].vars.value = Object.values(
            payload.choices,
          ).find(
            (choice) =>
              choice.value.toString() ===
              this.formModels[payload.parent].children[payload.index].children[payload.target].vars.value,
          );
        }
      }
      if (this.type === "trainingCourse_duplication" && this.formModels.referenceColumn.children[payload.target]) {
        this.formModels.referenceColumn.children[payload.target].loading = false;
      } else if (this.formModels[payload.target]) {
        this.formModels[payload.target].loading = false;
      }
    },

    isStickyBlock() {
      this.stickyFields = Object.values(this.models).filter(
        (model) => model.vars?.attr && model.vars.attr["data-form-sticky"],
      );
    },

    ajaxTargetTrig(payload) {
      let prefix = "";
      if (payload.trigger.vars.attr && payload.trigger.vars.attr["data-ajax-linked-to"]) {
        const ref = Object.values(this.models).find(
          (item) => item.vars.name === payload.trigger.vars.attr["data-ajax-linked-to"],
        );
        if (ref && ref.vars.value.data.id) {
          prefix = ref.vars.value.data.id + "/";
        }
        formManager.fieldLoad(payload.trigger, null, null, prefix, this.formModels, this.type).then((data) => {
          this.ajaxTargetLoad({
            choices: { ...data },
            target: Object.keys(payload.trigger.vars.attr["data-ajax-load"])[0],
          });
        });
      }
    },

    resetInputs(payload) {
      if (payload && payload.item) {
        Object.entries(payload.item).forEach((item) => {
          let target;
          if (this.type === "trainingCourse_duplication") {
            target = this.formModels.referenceColumn.children[item[0]];
          } else {
            target = this.formModels[item[0]];
          }
          this.resetChoices(target);
        });
      }
    },

    resetChoices(target) {
      if (target.vars.attr["data-ajax-load"]) {
        const children = this.formModels[Object.keys(target.vars.attr["data-ajax-load"])];
        this.formModels[target.vars.name].vars.choices = [];
        this.formModels[target.vars.name].vars.value = undefined;

        this.resetChoices(children);
      } else {
        this.formModels[target.vars.name].vars.choices = [];
        this.formModels[target.vars.name].vars.value = undefined;
      }
    },

    sortCollection() {
      this.$emit("sortCollection");
    },

    filter(payload) {
      this.$emit("filter", payload);
    },

    resetFilter() {
      this.$emit("resetFilter");
    },

    toggleTab(payload) {
      this.$emit("toggleTab", payload);
    },

    isSwitchType(model) {
      return formManager.isSwitchType(model);
    },
    isCheckboxType(model) {
      return formManager.isCheckboxType(model);
    },
    isRadioType(model) {
      return formManager.isRadioType(model);
    },

    selectTypeAction(payload) {
      this.$emit("selectTypeAction", payload);
    },

    buttonAction(payload) {
      this.$emit("buttonAction", payload);
      this.$emit(payload);
    },

    resetChildrenValue(model) {
      if (
        model &&
        model.vars.attr &&
        model.vars.attr["data-ajax-children"] &&
        model.vars.attr["data-ajax-children"].length
      ) {
        model.vars.attr["data-ajax-children"].forEach((item) => {
          const children = this.formModels.find((model) => model.vars.name === item);
          if (children && children.vars) {
            children.vars.value = null;
            children.vars.choices = [];
          } else {
            this.$emit("checkChildrenToReset", item);
          }
        });
      }
    },

    fetchConditionalChildren(payload) {
      this.$emit("fetchConditionalChildren", payload);
    },

    ...mapActions(useFormStore, ["resetParentAjaxParamsCorrespondingTable"]),
  },
};
</script>

<style lang="scss" scoped>
.non-empty {
  overflow: auto;
}

.grid {
  display: flex;

  .row {
    flex: 1;
  }
}

.form-group {
  position: relative;
  display: flex;
  align-items: end;
}

.stickyForm {
  min-width: 500px;
  flex: 0;

  &__content {
    z-index: 48;
    border: 1px dashed $m-color_4;
    margin-left: 45px;
    padding: 20px;
    height: auto;
    border-radius: 6px;
    position: sticky;
    top: 135px;
  }
}
</style>
